<template>
  <div class="page-navi">
    <div class="group-button left-button">
      <div class="button-first page-navi-button" :class="{ disabled: !prevExist }" @click="firstPage()">
        <!-- <b-tooltip target-id="Pierwsza strona"> -->
        <div class="navi-icon-image" :title="getTooltips['pierwsza']">
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiPoczatek-OFF.png" class="icon-off" />
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiPoczatek-ON.png" class="icon-on" />
        </div>
        <!-- </b-tooltip> -->
      </div>
      <div class="button-prev page-navi-button" @click="previusPage()" :class="{ disabled: !prevExist }">
        <!-- <b-tooltip target-id="Poprzednia strona"> -->
        <div class="navi-icon-image" :title="getTooltips['poprzednia']">
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiWstecz-OFF.png" class="icon-off" />
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiWstecz-ON.png" class="icon-on" />
        </div>
        <!-- </b-tooltip> -->
      </div>
    </div>
    <!-- <b-tooltip target-id="Numer strony"> -->
    <div class="center-input" :title="getTooltips['numerStrony']">
      <input
        type="text "
        ref="indexPage"
        name="indexPage"
        @click="focusOnEnter"
        @blur="onBlur"
        @keyup="keyMonitor"
        :value="getPageNumbersText"
      />
    </div>
    <!-- </b-tooltip> -->
    <div class="group-button right-button">
      <div class="button-next page-navi-button" :class="{ disabled: !nextExist }" @click="nextPage()">
        <!-- <b-tooltip target-id="Następna strona"> -->
        <div class="navi-icon-image" :title="getTooltips['nastepna']">
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiDalej-OFF.png" class="icon-off" />
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiDalej-ON.png" class="icon-on" />
        </div>
        <!-- </b-tooltip> -->
      </div>
      <div class="button-last page-navi-button" :class="{ disabled: !nextExist }" @click="lastPage()">
        <!-- <b-tooltip target-id="Ostatnia strona"> -->
        <div class="navi-icon-image" :title="getTooltips['ostatnia']">
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiKoniec-OFF.png" class="icon-off" />
          <img draggable="false" src="~@/assets/icons/book/pageNavi/nawiKoniec-ON.png" class="icon-on" />
        </div>
        <!-- </b-tooltip> -->
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'page-navi',
  props: [],
  data: function () {
    return {};
  },
  components: {},
  methods: {
    focusOnEnter() {
      this.$store.commit(`PAGE_INDEX_FOCUS`);
      this.$refs.indexPage.select();
    },
    onBlur() {
      this.$store.commit('PAGE_INDEX_BLUR');
    },
    keyMonitor: function (event) {
      if (event.key == 'Enter') {
        let index = parseInt(event.target.value);
        let findPage = null;
        this.$parent.$emit('jumpTo', index);
        // if (_.isNumber(index)) {
        //   findPage = _.find(this.$store.getters[`${this.correctModuleName}/getPages`], (doublePage) => {
        //     if (
        //       (doublePage.left && doublePage.left.id === index) ||
        //       (doublePage.right && doublePage.right.id === index)
        //     ) {
        //       return true;
        //     }
        //   });
        //   if (findPage && findPage.id !== this.$store.getters[`${this.correctModuleName}/getActualPage`].id) {
        //     console.log(' findPage.id', findPage.id);
        //     this.$store.commit(`${this.correctModuleName}/CHANGE_ACTUAL_PAGE`, findPage.id);
        //     // this.jumpTo( findPage.left.id || findPage.right.id || 0 );
        //     this.jumpTo(findPage.id + 1);
        //   } else {
        //     console.log('Not a number');
        //   }
        // } else {
        //   console.log('Page not exist');
        // }
      }
    },
    firstPage() {
      // console.log('firstPage');
      // this.$store.commit( 'FIRST_PAGE' );
      this.$parent.$emit('clearCanvas');
      this.$parent.$emit('firstPage');
    },
    previusPage() {
      // console.log('previusPage');
      // this.$store.commit( "PREVIUS_PAGE" );
      // this.$store.commit(`${this.correctModuleName}/CHANGE_ACTUAL_PAGE`, findPage.id);
      this.$parent.$emit('clearCanvas');
      this.$parent.$emit('previusPage');
    },
    jumpTo(id) {
      // console.log('jumpTo');
      // this.$store.commit( "PREVIUS_PAGE" );
      this.$parent.$emit('clearCanvas');
      this.$parent.$emit('jumpTo', id);
    },
    nextPage() {
      // console.log('nextPage');
      // console.log(this.$parent);
      // this.$store.commit( "NEXT_PAGE" );
      this.$parent.$emit('clearCanvas');
      this.$parent.$emit('nextPage');
    },
    lastPage() {
      // console.log('lastPage');
      // this.$store.commit( "LAST_PAGE" );
      this.$parent.$emit('clearCanvas');
      this.$parent.$emit('lastPage');
    },
  },
  computed: {
    correctModuleName() {
      let name = this.$store.getters.multibookType;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    nextExist() {
      return this.$store.getters[`${this.correctModuleName}/nextExist`];
    },
    prevExist() {
      return this.$store.getters[`${this.correctModuleName}/prevExist`];
    },
    getDoublePageNumbersText() {
      return this.$store.getters[`${this.correctModuleName}/getDoublePageNumbersText`];
    },
    getPageNumbersText() {
      let pageIndex = this.getDoublePageNumbersText;
      if (pageIndex === '0 – 1') {
        pageIndex = '1';
      }
      return pageIndex;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/variable';

.disabled {
  opacity: 0;
  pointer-events: none;
}
.page-navi {
  display: flex;
  flex-direction: row;
  margin-left: -8px;
  // width: 25vw;
  // padding-left: 13.5vw;
  // padding-left: 259px;
  justify-content: center;
}
.page-navi-button {
  width: $naviIconImageWidth;
  // height: $naviIconImageHeight;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.group-button {
  display: flex;
  justify-content: space-around;
}
.center-input {
  width: $naviTextInputWidth;
  display: flex;
  align-items: flex-start;
  padding-top: 12px;
  padding-left: 0.3vw;
  input {
    border: none;
    width: 100%;
    height: 43px;
    text-align: center;
    font-size: $naviTextInputSize;
  }
}
.left-button {
  .page-navi-button {
    margin-right: 20px;
  }
}
.right-button {
  .page-navi-button {
    margin-left: 20px;
  }
}
.navi-icon-image {
  width: $naviIconImageWidth;
  height: $naviIconImageHeight;
  position: relative;
  visibility: visible;
  opacity: 1;
  // transition: visibility 0s, opacity 0.3s ease-in;
}
.navi-icon-image .icon-off {
  width: 100%;
  height: 100%;
  visibility: visible;
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  // z-index: 99;
  transition: visibility 0s, opacity 0.5s ease-out;
}
.navi-icon-image .icon-on {
  // display: none;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  // z-index: 99;
  transition: visibility 0s, opacity 0.5s ease-out;
}
.navi-icon-image:hover .icon-on {
  // display: inline;
  visibility: visible;
  opacity: 1;
  // transition: visibility 0s, opacity 0.3s ease-in;
}
</style>
